import React, { useMemo, Fragment } from 'react';
import ContentLoader from 'react-content-loader';

import './styles.scss';

const TabsPlaceholder = ({ height = 120, width = 512, theme, ...props }) => {
    const rowHeight = 50;
    const numRows = Math.floor(height / rowHeight);

    const titleWidth = width * 0.19;
    const borderWidth = width * 0.94;
    const nameWidth = width * 0.225;
    const dateWidth = width * 0.131;

    const firstTitlePosition = width * 0.02;
    const secondTitlePosition = width * 0.25;
    const thirdTitlePosition = width * 0.48;
    const fourthTitlePosition = width * 0.71;

    const circleRadius = width <= 512 ? width * 0.0265 : 14;
    const circlePosition = width * 0.0265;
    const namePosition = width * 0.071;
    const datePosition = width * 0.79;

    const renderRows = useMemo(() => {
        let rows = [];
        let baseTextY = 38;
        let baseCircleY = 50;

        for (let i = 0; i < numRows; i++) {
            rows.push(
                <Fragment key={i}>
                    <circle cx={circlePosition} cy={baseCircleY} r={circleRadius} opacity="0.2" />
                    <rect
                        x={namePosition}
                        y={baseTextY}
                        rx="3"
                        ry="3"
                        width={nameWidth}
                        height="8"
                    />
                    <rect
                        x={datePosition}
                        y={baseTextY + 17}
                        rx="3"
                        ry="3"
                        width={dateWidth}
                        height="8"
                    />
                </Fragment>,
            );
            baseCircleY = baseCircleY + rowHeight;
            baseTextY = baseTextY + rowHeight;
        }
        return rows;
    }, [circlePosition, circleRadius, datePosition, dateWidth, namePosition, nameWidth, numRows]);

    return (
        <div className="fm-tabs__placeholder">
            <ContentLoader
                height={height}
                width={width}
                speed={2}
                backgroundColor={theme.colors.grey[50]}
                foregroundColor={theme.colors.grey[100]}
                {...props}
            >
                <rect x={firstTitlePosition} y="0" rx="3" ry="3" width={titleWidth} height="8" />
                <rect x={secondTitlePosition} y="0" rx="3" ry="3" width={titleWidth} height="8" />
                <rect x={thirdTitlePosition} y="0" rx="3" ry="3" width={titleWidth} height="8" />
                <rect x={fourthTitlePosition} y="0" rx="3" ry="3" width={titleWidth} height="8" />
                <rect x="0" y="22" rx="3" ry="3" width={borderWidth} height="1" />
                {renderRows}
            </ContentLoader>
        </div>
    );
};

export default TabsPlaceholder;
